import { useState, type ReactNode } from 'react';

interface Props<T> {
  title: string;
  description?: string;
  count?: string;
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  filterFn?: (item: T, query: string) => boolean;
  height?: number;
}

export default function ListWidget<T>({ title, description, count, items, renderItem, filterFn, height = 380 }: Props<T>) {
  const [query, setQuery] = useState('');

  const filtered = query && filterFn
    ? items.filter(item => filterFn(item, query.toLowerCase()))
    : items;

  return (
    <div className="pi-widget-card" style={{ height }}>
      <div className="pi-widget-header">
        <div>
          <h3>{title}</h3>
          {description && <div className="description">{description}</div>}
        </div>
        {count && <span className="count-badge">✦ {count}</span>}
      </div>
      <div className="pi-filter-bar">
        <input
          type="text"
          placeholder="Filter this list..."
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
        {query && <button onClick={() => setQuery('')}>Clear</button>}
      </div>
      <div className="pi-widget-body">
        {filtered.length === 0 ? (
          <div style={{ padding: 24, textAlign: 'center', color: '#545b50', fontSize: '0.75rem' }}>
            No items found
          </div>
        ) : (
          filtered.map((item, i) => renderItem(item, i))
        )}
      </div>
    </div>
  );
}
